import { create } from 'zustand';

type PurchaseType = 'all' | 'cart' | 'quick';
type NoticeType = 'snackbar' | 'toast' | 'tooltip';

export interface BottomSheetOption {
  placement?: string;
  purchaseType?: PurchaseType;
  noticeType?: NoticeType;
  useCrossSell?: boolean;
}

const defaultBottomSheetOption: BottomSheetOption = {
  placement: '상품목록',
  purchaseType: 'all',
  noticeType: 'snackbar',
  useCrossSell: true,
};
interface Store {
  bottomSheetOption: BottomSheetOption;
  opened: boolean;
  setOpened: (flag: boolean) => void;
  closeBottomSheet: () => void;
  openBottomSheet: (option?: BottomSheetOption) => void;
}

const useProductBottomSheetStore = create<Store>((set) => ({
  bottomSheetOption: defaultBottomSheetOption,
  opened: false,
  setOpened: (flag: boolean) => set(() => ({ opened: flag })),
  closeBottomSheet: () => {
    set(() => ({
      opened: false,
    }));
  },
  openBottomSheet: (option?: BottomSheetOption) => {
    set(() => ({
      bottomSheetOption: { ...defaultBottomSheetOption, ...option },
      opened: true,
    }));
  },
}));

export default useProductBottomSheetStore;
